import { Dialog } from "@order-analyzer/ui";
import { RELEASE_NOTES, renderInline } from "../lib/changelog.js";

export function ReleaseNotesDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} title="Release Notes" description="Änderungshistorie von OrderAnalyzer." className="max-w-2xl">
      {/* Dialog rendert Kinder unabhaengig von "open" (nur das native <dialog>-Element wird ein-/
          ausgeblendet) - ohne diese Bedingung waere der gesamte, sehr lange Changelog-Text bei
          jedem Seitenaufruf im DOM vorhanden, unsichtbar aber trotzdem u.a. fuer
          getByText()-Tests auffindbar (Kollisionen mit gleichlautenden sichtbaren Texten). */}
      {open && (
        <div className="flex flex-col gap-6">
          {RELEASE_NOTES.map((entry) => (
            <div key={entry.version} className="flex flex-col gap-2 border-b border-slate-100 pb-6 last:border-0 last:pb-0 dark:border-slate-800">
              <div className="flex items-baseline gap-2">
                <h3 className="text-sm font-semibold text-ink dark:text-slate-100">Version {entry.version}</h3>
                <span className="text-xs text-slate-400 dark:text-slate-500">{entry.date}</span>
              </div>
              {entry.summary && <p className="text-sm text-slate-600 dark:text-slate-300">{entry.summary}</p>}
              {entry.sections.map((section) => (
                <div key={section.heading} className="flex flex-col gap-1">
                  <p className="text-xs font-medium uppercase tracking-wide text-slate-400 dark:text-slate-500">{section.heading}</p>
                  <ul className="list-disc space-y-1 pl-5 text-sm text-slate-600 dark:text-slate-300">
                    {section.items.map((item, i) => (
                      <li key={i}>{renderInline(item)}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </Dialog>
  );
}
